<template>
  <div class="cardTicket-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline" label-width="82px">
        <el-form-item  label="手机号：" prop="userPhone">
          <el-input class="wd" v-model="form.userPhone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="商品内容：" class="productName"  prop="productName">
          <el-input class="wd" v-model="form.productName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="购买门店：" class="homepageSelect" prop="shopName">
          <el-select class="wd" v-model="form.shopName" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.shopName"
              :value="item.shopName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：" class="date" prop="date">
          <el-date-picker
            class="wd"
            v-model="form.date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <div class="operate">
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </div>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="联系方式" align="center"></el-table-column>
        <el-table-column prop="productName" label="购买内容" align="center"></el-table-column>
        <el-table-column prop="buyNum" label="购买数量" align="center"></el-table-column>
        <el-table-column prop="shopName" label="购买门店" align="center"></el-table-column>
        <el-table-column prop="orderId" label="小票单号" align="center"></el-table-column>
        <el-table-column prop="ticketIntegral" label="积分" align="center"></el-table-column>
        <el-table-column prop="buyTime" label="购买时间" align="center"></el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { getBuyRecordList, getAppShopList, exportBuyRecord } from '@/api/buyRecord';
import Excel from '@/mixins/export';
import Pagination from '@/components/Pagination';

export default {
  mixins: [Excel],
  data() {
    return {
      dialogVisible: false,
      dislogData: {
        id: '',
        userState: '',
        reason: '',
        store: '',
      },
      options: [],
      form: {
        productName: '',
        userPhone: '',
        shopName: '',
        date: [],
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getAppShopList();
    this.getBuyRecordList();
  },
  methods: {
    getAppShopList() {
      getAppShopList().then((res) => {
        if (res.success) {
          this.options = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 参数处理
    DealParameter() {
      const { region, date, ...rest } = this.form;
      const [beginTime, endTime] = date;
      return {
        ...rest,
        beginTime,
        endTime,
      };
    },
    getBuyRecordList() {
      this.loading = true;
      const data = this.DealParameter();
      return getBuyRecordList({
        ...data,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getBuyRecordList();
    },
    // 导出
    handleExport() {
      const data = this.DealParameter();
      exportBuyRecord(data).then((res) => {
        this.exportExcel(res, '购买记录列表');
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getBuyRecordList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getBuyRecordList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getBuyRecordList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
  .operate
    margin-bottom 20px
    width 100%
    flex-row()
    justify-content flex-end
  .wd
    width 400px!important
.phone,.homepageSelect
  // margin-left 20px
>>>textarea
  min-height 90px !important
</style>
